import { FormLabel } from "@mui/material";
import { styled } from "@mui/system";

const StyledFormLabels = styled(FormLabel)(({ theme }) => ({
  // MUI turns a focused label grey (#8c8c8c, too light to read); keep it dark
  [`&.Mui-focused`]: {
    color: "#344054",
  },
  [`&.Mui-error`]: {
    color: theme.palette.error.dark,
  },
  color: "#344054",
  ...theme.typography.h6,
  fontWeight: 500,
  textAlign: "left",
  marginBottom: "5px",
}));
export default StyledFormLabels;
